import React from "react";
import { useRoutes } from "react-router-dom";

import { Home } from "./Pages/Home";
import Error from "./Pages/Error/Error";

const routes = [
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/home",
    element: <Home />
  },
  {
    path: "/error",
    element: <Error />
  },
  {
    path: "*",
    element: <Error />
  }
];

const App = () => useRoutes(routes);

export default App;
